import React from 'react';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

const UserPhoto = ({ userName, userPhoto, onClick }) => {
  return (
    <IconButton onClick={onClick}>
      <Avatar alt={userName} src={userPhoto || "/path/to/default/avatar.jpg"} />
    </IconButton>
  );
};

export default UserPhoto;